import type {ReactElement} from 'react';
import {useEffect} from 'react';
import type {EmbeddedEditorCallbackLegacy} from '@Libraries/embedded-editor';
import {EmbeddedEditorAction, openDesignInEmbeddedEditor} from '@Libraries/embedded-editor';
import {noop} from '@Utils/general.util';
import {CircularProgressLoader} from '@Components/circular-progress-loader';
import {useDesignsToPublish} from '@Components/social-media-wizard/social-media-wizard.hooks';
import styles from './template-editor-panel.module.scss';
import type {DesignSelection} from '@Components/social-media/social-media.types';

interface TemplateEditorPanelProps {
  onSave: EmbeddedEditorCallbackLegacy;
  onClose: VoidFunction;
}

const getFirstTemplate = (templates: DesignSelection[]): DesignSelection | null => {
  if (templates.length === 0) {
    return null;
  }

  return templates[0];
};

export function TemplateEditorPanel({...props}: TemplateEditorPanelProps): ReactElement<any> | null {
  const templates = useDesignsToPublish();
  const template = getFirstTemplate(templates);

  useEffect(() => {
    if (template) {
      openDesignInEmbeddedEditor(
        template.posterHashedId,
        noop,
        (designId): void => {
          props.onSave(designId);
        },
        props.onClose,
        EmbeddedEditorAction.COPY,
        window.i18next.t('pmwjs_publish_next'),
        undefined
      );
    }
  }, []);

  return (
    <div className={styles.progressContainer}>
      <CircularProgressLoader classes={styles.marginAuto} />
    </div>
  );
}
